// removed by extract-text-webpack-plugin
module.exports = {"container":"F0f9yMm2bdAWhjAfrgSxL","title":"syNVoJAu5JLUlf4IRJ1L8","name":"_3K91z7TfTbJQO2kfQym56Y","Button":"_3A7epHWJBK-_HzPKBMMXbk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Status/Title/styles.css
// module id = 2841
// module chunks = 0